<div class="row  justify-content-lg-end justify-content-md-end justify-content-sm-between justify-content-between align-items-center">
  <div class="col">
    <div class="input-group">
      <p-checkbox
                    class="table-header-checkbox"
                    [disabled]="disable"
                    inputId="cbx"
                    [(ngModel)]="value"
                    checkboxPosition="right"
                    (onChange)="test()"
                    [label]="label"
                    binary="true"
                    style="flex-direction: row-reverse"
                    >

      </p-checkbox>
      <ng-template #popTemplate>
        <div *ngIf="!!popoverText" [ngClass]="'optional-input-guide'"
             [innerHtml]="popoverText"></div>
      </ng-template>
      <div class="input-group-append" *ngIf="popoverText" style="margin-left: 10px; margin-top: -8px">
        <app-eca-input-guide [popoverText]="popoverText" [isRequired]="false" [isDisabled]="disable"></app-eca-input-guide>
      </div>
    </div>
  </div>
</div>
